/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown>, count: NonNullable<unknown> }} Samples_Bulk_SuccessInputs */

const en_samples_bulk_success = /** @type {(inputs: Samples_Bulk_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.count} sample(s)`)
};

const es_samples_bulk_success = /** @type {(inputs: Samples_Bulk_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.count} muestra(s)`)
};

/**
* | output |
* | --- |
* | "{label} {count} sample(s)" |
*
* @param {Samples_Bulk_SuccessInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_bulk_success = /** @type {((inputs: Samples_Bulk_SuccessInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Bulk_SuccessInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_bulk_success(inputs)
	return es_samples_bulk_success(inputs)
});